import React from 'react';
import { Inline } from '@styleseat/ui';
import AdminMenuContainer from '../AdminMenu';
import DropdownFeed from '../../notifications/DropdownFeed';
import ProHeaderDropdown from '../ProHeaderDropdown';

export type AccountToolsProps = {
  providerId?: number;
  isBlockedFromAppliation?: boolean;
};

const AccountTools = ({
  providerId,
  isBlockedFromApplication,
}) => (
  <Inline alignItems="center" space={12}>
    <AdminMenuContainer providerId={providerId} />
    {providerId && !isBlockedFromApplication ? (
      <DropdownFeed
        providerId={providerId}
      />
    ) : null}
    {providerId ? (
      <ProHeaderDropdown providerId={providerId} />
    ) : null}
  </Inline>
);

export default AccountTools;
